import { jsx, jsxs } from "react/jsx-runtime";
import { track, useQuickReactor, useValue } from "@tldraw/state-react";
import { useLayoutEffect, useRef } from "react";
import { useEditorComponents } from "../hooks/EditorComponentsContext.mjs";
import { useEditor } from "../hooks/useEditor.mjs";
import { useSharedSafeId } from "../hooks/useSafeId.mjs";
import { isCursorInViewport } from "../utils/collaborators.mjs";
import { setStyleProperty } from "../utils/dom.mjs";
import { getHtmlLayerTransform } from "../utils/getHtmlLayerTransform.mjs";
const LiveCollaborators = track(function LiveCollaborators2() {
  const editor = useEditor();
  const { CollaboratorCursor } = useEditorComponents();
  const rHtmlLayer = useRef(null);
  useLayoutEffect(() => {
    const elm = rHtmlLayer.current;
    if (!elm) return;
    setStyleProperty(elm, "transform", getHtmlLayerTransform(editor));
  });
  useQuickReactor(
    "position collaborators layer",
    function positionCollaboratorsWhenCameraMoves() {
      const transform = getHtmlLayerTransform(editor);
      setStyleProperty(rHtmlLayer.current, "transform", transform);
    },
    [editor]
  );
  const collaborators = editor.getVisibleCollaboratorsOnCurrentPage();
  if (collaborators.length === 0) return null;
  if (!CollaboratorCursor) return null;
  return /* @__PURE__ */ jsxs("div", { className: "tl-collaborators", children: [
    /* @__PURE__ */ jsx("svg", { className: "tl-svg-context", "aria-hidden": "true", children: /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(CursorDef, {}) }) }),
    /* @__PURE__ */ jsx("div", { ref: rHtmlLayer, className: "tl-html-layer", children: collaborators.map((presence) => /* @__PURE__ */ jsx(Collaborator, { latestPresence: presence }, presence.userId)) })
  ] });
});
const Collaborator = track(function Collaborator2({
  latestPresence
}) {
  const editor = useEditor();
  const { CollaboratorCursor } = useEditorComponents();
  const { userId, chatMessage, userName, cursor, color } = latestPresence;
  const cursorInViewport = useValue(
    "cursor in viewport",
    () => !!cursor && isCursorInViewport(cursor, editor.getViewportPageBounds(), editor.getZoomLevel()),
    [editor, cursor]
  );
  const zoomLevel = editor.getZoomLevel();
  if (!cursor) return null;
  if (!cursorInViewport) return null;
  if (!CollaboratorCursor) return null;
  return /* @__PURE__ */ jsx(
    CollaboratorCursor,
    {
      className: "tl-collaborator__cursor",
      userId,
      point: cursor,
      color,
      zoom: zoomLevel,
      name: userName !== "New User" ? userName : null,
      chatMessage: chatMessage ?? ""
    }
  );
});
function CursorDef() {
  return /* @__PURE__ */ jsxs("g", { id: useSharedSafeId("cursor"), children: [
    /* @__PURE__ */ jsxs("g", { fill: "rgba(0,0,0,.2)", transform: "translate(-11,-11)", children: [
      /* @__PURE__ */ jsx("path", { d: "m12 24.4219v-16.015l11.591 11.619h-6.781l-.411.124z" }),
      /* @__PURE__ */ jsx("path", { d: "m21.0845 25.0962-3.605 1.535-4.682-11.089 3.686-1.553z" })
    ] }),
    /* @__PURE__ */ jsxs("g", { fill: "white", transform: "translate(-12,-12)", children: [
      /* @__PURE__ */ jsx("path", { d: "m12 24.4219v-16.015l11.591 11.619h-6.781l-.411.124z" }),
      /* @__PURE__ */ jsx("path", { d: "m21.0845 25.0962-3.605 1.535-4.682-11.089 3.686-1.553z" })
    ] }),
    /* @__PURE__ */ jsxs("g", { fill: "currentColor", transform: "translate(-12,-12)", children: [
      /* @__PURE__ */ jsx("path", { d: "m19.751 24.4155-1.844.774-3.1-7.374 1.841-.775z" }),
      /* @__PURE__ */ jsx("path", { d: "m13 10.814v11.188l2.969-2.866.428-.139h4.768z" })
    ] })
  ] });
}
export {
  LiveCollaborators
};
//# sourceMappingURL=LiveCollaborators.mjs.map
